import React from 'react';

const SpaOverview = ({ language }) => {
  return (
    <section className="container py-5">
     <h2 className="fw-bold mb-4">
  {language === 'am' ? 'አጠቃላይ እይታ' : 'Overview'}
</h2>

<p>
  {language === 'am'
    ? 'የኛ ስፓ እና የእንፋሎት ማእከል ለጠቅላላ መዝናናት እና ማደስ የተሰራ ነው። ከእንፋሎት እስከ የማሳጅ ቴራፒ ድረስ ባለው የተሟላ የጤና ህክምና ይደሰቱ - ሁሉም በሰለጠኑ ባለሙያዎች ይሰጣሉ።'
    : 'Our Spa & Steam Center is designed for total relaxation and rejuvenation. Enjoy a full range of wellness treatments, from steam and sauna to massage therapy — all delivered by trained professionals.'}
</p>

<p>
  {language === 'am'
    ? 'ፋሲሊቲዎች በሚያምር ሁኔታ ያጌጡ እና በመደበኛነት ይጸዳሉ። እንግዶች ደህንነቱ የተጠበቀ መቆለፊያዎች፣ ለስላሳ ብርሃን እና ለአእምሮ ሰላም ተስማሚ የሆነ የተረጋጋ አካባቢ ማግኘት ይደሰታሉ።'
    : 'Facilities are beautifully decorated and regularly sanitized. Guests enjoy access to secure magnetic lockers, soft lighting, and a calm environment ideal for peace of mind.'}
</p>

<p>
  {language === 'am'
    ? 'ከ ሰኞ እስከ እሁድ፣ ከጠዋት 8:00 እስከ ምሽት 10:00 ድረስ ክፍት የሆነው ማዕከሉ፣ ለንፅህና እና ለመስተንግዶ የሚያስቀድሙ ሰዎች መተሙላ ነው።'
    : 'Open every day from Monday to Sunday, 8:00 AM – 10:00 PM, the center is a sanctuary for those who value both hygiene and hospitality.'}
</p>

<h4 className="mt-4">
  {language === 'am' ? 'መሳሪያዎች' : 'Facilities'}
</h4>

<div className="table-responsive">
  <table className="table table-bordered mt-3">
    <thead className="table-light">
      <tr>
        <th>{language === 'am' ? 'ዋና መለያዎች' : 'Feature'}</th>
        <th>{language === 'am' ? 'መግለጫ' : 'Description'}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{language === 'am' ? 'ማሳጅ' : 'Massage'}</td>
        <td>{language === 'am' ? 'ባለሙያ የሰውነት ሙሉ እና የደህንነት ማሳጅ ሕክምና' : 'Professional full-body and relaxation massage therapy'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'ስቲም እና ሳውና' : 'Steam & Sauna'}</td>
        <td>{language === 'am' ? 'ዘመናዊ ሳውና እና የውሃ ስቲም ስርዓት ጋር' : 'Modern sauna with integrated water steam system'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'ንፅህና' : 'Hygiene'}</td>
        <td>{language === 'am' ? 'ለንፅህና እና ለአስተማማኝነት ከፍተኛ ደረጃዎች' : 'High standards for cleanliness and comfort'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'ሎከር' : 'Locker'}</td>
        <td>{language === 'am' ? 'ለእንግዶች ግላዊነት የማግኔቲክ ቁልፍ ያለው ደህንነቱ የተጠበቀ ሎከር' : 'Magnetic-lock secure lockers for guest privacy'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'ሰራተኞች' : 'Staff'}</td>
        <td>{language === 'am' ? 'ብቁ የስፓ ባለሙያዎች' : 'Trained and certified spa professionals'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'ስራ ሰዓት' : 'Hours'}</td>
        <td>{language === 'am' ? 'ከጠዋት 8:00 እስከ ምሽት 10:00 ድረስ ክፍት ነው' : 'Open daily from 8:00 AM to 10:00 PM'}</td>
      </tr>
    </tbody>
  </table>
      </div>
    </section>
  );
};

export default SpaOverview;
